import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import { BasePage } from '@sm/webassets';
import { Typography } from '@sm/wds-react';
import IntlKitchenSink from '@sm/webassets/src/kitchensinks/IntlKitchenSink';

const Home = () => (
  <>
    <Typography variant="hero1" component="h1">
      ContentWeb Sinks
    </Typography>
    <Typography variant="sectionTitle">
      <Link to="/kitchensink/contentweb/intl">L10N</Link>
    </Typography>
  </>
);

const KitchenSink = () => (
  <BasePage pageId="Contentweb KitchenSink" legacyWeb="contentweb">
    <Switch>
      <Route exact path="/kitchensink/contentweb/" render={() => <Home />} />
      <Route
        exact
        path="/kitchensink/contentweb/intl"
        render={() => <IntlKitchenSink />}
      />
    </Switch>
  </BasePage>
);

export default KitchenSink;
